import { ActivityViewModel } from '../../../view-models/scheckheft-detail-view-model';


export class ScheckheftActivityFilterValueConverter{
    toView(array: ActivityViewModel[], filter:string){
        var result = array.filter(a => a.category == filter);
        return result;
    }
}